exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.payment-blocked-view[data-v-28caf2c0] {\n  min-height: 100vh;\n}\n", ""]);

// exports
